<template>
  <div class="row">
    <div class="service">
      <div class="col-12">
        <table class="table border table-striped">
          <thead>
            <tr>
              <th
                scope="col"
                colspan="2"><h4 class="text-center">Thông tin của bạn</h4></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in temp">
              <td>{{ item.display }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </table>

        <table class="table border table-striped">
          <tbody>
            <tr>
              <td>Tên dịch vụ</td>
              <td>{{ service.name }}</td>
            </tr>
            <tr>
              <td>Giá dịch vụ</td>
              <td style="font-weight: bold; font-style: italic; color: red">{{ formatPrice(service.cost) }} vnđ</td>
            </tr>
            <tr>
              <td>Khuyến mãi</td>
              <td style="font-weight: bold; font-style: italic; color: red">{{ formatPrice(sale) }} vnđ</td>
            </tr>
            <tr>
              <td>Thanh toán</td>
              <td style="font-weight: bold; font-style: italic; color: red">{{ formatPrice(payment) }} vnđ</td>
            </tr>
          </tbody>
        </table>
        <button
          type="button"
          class="btn btn-order bg-green"
          @click="orderService()">Mua dịch vụ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import {errorToaster} from '../../services/ErrorHandler'
  import OrderType from '../../communicate/OrderType'
  import {getPhone} from '../../services/authService'
  import PaymentMethod from '../../communicate/PaymentMethod'

  export default {
    name: 'Preview',
    data () {
      return {
        service: JSON.parse(localStorage.getItem('service')),
        flash: JSON.parse(localStorage.getItem('flash_sale')),
        orders: JSON.parse(localStorage.getItem('orders')),
        sale: 0,
        payment: 0,
        temp: []
      }
    },

    mounted () {
      if (this.flash.description) {
        if (this.flash.payment_method === PaymentMethod.PAYMENT_VTC_PAY) {
          if (this.service.code === 'PT-DV-101' || this.service.code === 'PT-DV-88' || this.service.code === 'PT-DV-103') {
            this.sale = this.flash.is_fix === 0 ? parseFloat(this.service.cost * this.flash.sale / 100) : this.flash.is_fix;
            this.sale = parseFloat(this.flash.max_discount) < this.sale ? parseFloat(this.flash.max_discount)  : this.sale;
            this.payment = this.service.cost - this.sale;
          } else {
            this.sale = 0;
            this.payment = this.service.cost;
          }
        } else {
          this.sale = 0;
          this.payment = this.service.cost;
        }
      } else {
        this.sale = 0;
        this.payment = this.service.cost;
      }

      const attributes = this.orders.attrs
      this.temp = attributes.map(item => {
        let display = '';
        let value = item.value;
        if (item.code === 'full_name') {
          display = 'Họ và tên'
        }
        if (item.code === 'nam_sinh_cua_ban') {
          display = 'Năm sinh của bạn'
        }
        if (item.code === 'gioi_tinh') {
          display = 'Giới tính'
          value = value === 1 ? 'Nam' : 'Nữ'
        }
        if (item.code === 'gio_sinh') {
          display = 'Giờ sinh'
        }
        return {
          value: value,
          display: display,
          code: item.code
        }
      })
    },

    methods: {

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      orderService () {
        rf.getRequest('ServiceRequest').orderService(this.orders).then((res) => {
          if (res.status === 200) {
            if (parseFloat(res.data.price) > 0) {
              const req = {
                order_id: res.data.order_id,
                order_code: res.data.order_code,
                customer_number: getPhone(),
                description: `Thanh toan don hang ${res.data.order_code}`,
                amount: parseInt(res.data.price),
                payment_type: OrderType.ORDER_DV
              }
              this.requestViettel(req)
            }
          } else if (res.status === 401 || res.status === 403) {
            this.$router.push('/login')
          } else {
            errorToaster('Cố vấn phong thủy', res.message)
          }
        }).catch(err => {
          errorToaster('Cố vấn phong thủy', 'Xảy ra lỗi kết nối')
        })
      },

      requestViettel (req) {
        rf.getRequest('OrderRequest')
          .vtcPay(req)
          .then(res => {
            if (res.status === 200) {
              window.location.href = res.data
            } else {
              errorToaster('Cố vấn Phong Thủy', res.message)
            }
          })
          .catch(err => {
            errorToaster('Cố vấn Phong Thủy', 'Xảy ra lỗi kết nối')
          })
      },

      listLaso () {
        this.$router.push('/laso')
      },

      onSlideStart () {
        this.sliding = false
        this.description = this.service.description
      },

      onSlideEnd () {
        this.sliding = true
        this.description = this.service.description ? this.service.description.substring(0, 250) + '...' : ''
      },
    }

  }
</script>

<style scoped>
  .table {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/payment/Preview.vue